// Phase-102 · 403 page used by RoleGate.
import { ShieldAlert } from "lucide-react";
import { Link } from "react-router-dom";

export default function Forbidden403({ reason = "Access denied", role = "" }) {
  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center text-center px-6"
         data-testid="forbidden-403">
      <div className="w-16 h-16 bg-rose-50 border border-rose-200 rounded-2xl flex items-center justify-center mb-5">
        <ShieldAlert className="h-8 w-8 text-rose-600" />
      </div>
      <h1 className="font-['Outfit'] text-2xl font-bold text-slate-900 mb-1">
        403 — Forbidden
      </h1>
      <p className="text-sm text-slate-600 max-w-md mb-1">{reason}</p>
      {role && <p className="text-xs text-slate-400 mb-5">Your role: <span className="font-mono">{role}</span></p>}
      <Link to="/dashboard" className="text-sm text-orange-600 hover:underline">
        ← Back to dashboard
      </Link>
    </div>
  );
}
